import { render, staticRenderFns } from "./SubmitDeclarationsModal.vue?vue&type=template&id=c13a45b2&scoped=true&"
import script from "./SubmitDeclarationsModal.vue?vue&type=script&lang=js&"
export * from "./SubmitDeclarationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13a45b2",
  null
  
)

export default component.exports